import React, { useEffect, useState } from 'react';
import useUiStateStore from '../../_store/useUiStateStore';
import axiosWrapper from '../../_utils/Axios';
import { sanitizeInput } from '../../_utils/Validation';
import { debounce } from 'lodash';
import { validationName, validateBirthdate, validatePhoneNumber, validateCompany } from '../../_utils/Validation';
import NotiPopup from '../NotiPopup/NotiPopup';
import './FreeVoucherPopup.scss';
import formDefaultData from '../../_constants/formDefaultData';

const FreeVoucherPopup = (props) => {
    const { isRegistPopupOpen, setRegistPopupOpen, isCheckupCardPopupOpen, setSubmitOkPopupOpen } = useUiStateStore();
    const [formValues, setFormValues] = useState(formDefaultData);
    const [isCodeValidateOk, setIsCodeValidateOk] = useState(false);
    const [codeResponseText, setCodeResponseText] = useState('');
    const [submitResponseText, setSubmitResponseText] = useState('');

    useEffect(() => {
    }, [isCheckupCardPopupOpen]);

    const popupCloseBtnClick = () => {
        resetFormValues();
        setRegistPopupOpen(false);
    };

    const resetFormValues = () => {
        setFormValues(formDefaultData);
        setIsCodeValidateOk(false);
        setCodeResponseText('');
    };

    const validationForm = () => {
        setFormValues(
            {
                ...formValues,
                hpNo: formValues.hpNo.replaceAll("-", "")
            }
        )
        
        if(formValues.name === "") {
            alert("이름을 입력해주세요.");
            return false;
        }

        if(!validationName(formValues.name)) {
            alert("이름형식을 확인해주세요. (최소 2자 이상)");
            return false;
        }

        if(formValues.birthDay === "") {
            alert("생년월일을 입력해주세요.");
            return false;
        }

        if(!validateBirthdate(formValues.birthDay)) {
            alert("생년월일은 숫자8자리 입니다. (특수기호 포함x)");
            return false;
        }

        if(formValues.hpNo === "") {
            alert("휴대폰번호를 입력해주세요.");
            return false;
        }

        if(!validatePhoneNumber(formValues.hpNo.replaceAll("-", ""))) {
            alert("휴대폰번호는 숫자11자리 입니다. (특수기호 포함x)");
            return false;
        }

        if(formValues.customerNm === "") {
            alert("회사명/단체명을 입력해주세요.");
            return false;
        }

        if(!validateCompany(formValues.customerNm)) {
            alert("회사명/단체명은 1글자 이상의 영문 혹은 한글, 최대 200글자 미만입니다.");
            return false;
        }

        if(!isCodeValidateOk) {
            alert("코드 인증을 진행해주세요.");
            return false;
        }

        return true;
    }

    const submitBtnClick = debounce(() => {
        if(validationForm()) {
            const payload = formValues;

            axiosWrapper('POST', `hello/micro/voucher/freeVoucher`, payload)
            .then((res) => {
                if(res.status === 200) {
                    if(res.data.data) {
                        console.log('voucher regist ok', res.data);
                        setSubmitOkPopupOpen(true);
                    }
                } else {
                    console.log('voucher regist error', res.data.message);
                    alert("voucher regist error", res.data.message);
                    setSubmitResponseText(res.data.message);
                }
            })
            .catch((error) => {
                console.log('freeVoucher call error', error);
                if(error.status === 500) {
                    alert(error.response.data.message);
                    setSubmitResponseText(error.response.data.message);
                }
            });
        }
    }, 500);

    const validationCodeBtnClick = debounce(() => {
        if(formValues.voucherCode !== '') {
            axiosWrapper('GET', `hello/micro/voucher/validateVoucherCode/${encodeURIComponent(formValues.voucherCode)}`)
            .then((res) => {
                if(res.status === 200) {
                    setCodeResponseText(res.data.message);
    
                    if(res.data.data) {
                        console.log('voucher validation ok', res.data);
                        setIsCodeValidateOk(true);
                        setCodeResponseText("코드 인증에 성공하였습니다.");
                    } else {
                        setIsCodeValidateOk(false);
                    }
                } else {
                    alert("server error", res.status);
                }
                
            })
            .catch((error) => {
                console.log('validateVoucherCode call error', error);
            });
        } else {
            alert("코드 번호를 입력하세요.");
        }
    }, 500);

    return (
        <> 
            { isRegistPopupOpen ? ( 
                <div className="card-content">
                    <ul className="card-content-list">
                        <li> 
                            <div className="title-area">
                                <div>
                                    <strong>무료 이용권 신청</strong>
                                </div>
                                <button className="btn-modal-close" onClick={() => popupCloseBtnClick()}>
                                    <img alt=""/>
                                    <span className="blind">닫기</span>
                                </button>
                            </div>

                            <div className="desc-area">
                                <div className="contents-section-title">
                                    <strong className="fc-black">발급 받은 코드를 등록하여 신청을 진행해주세요. 이용권 코드를 카카오톡으로 보내드립니다.</strong>
                                </div>

                                <div>
                                    <form>
                                        <div className="contact-form">
                                            <div className="contact-infolist-area popup-area">
                                                <div className="flex-area half">
                                                    <div className="contact-infolist-box">
                                                        <div className="contact-info-label">
                                                            <span>신청자명</span><span className='essential'>*</span>
                                                        </div>

                                                        <div className="info-value-default">
                                                            <input 
                                                                type="text"
                                                                name="name"
                                                                placeholder="성명을 입력해주세요."
                                                                value={formValues.name}
                                                                onChange={(e) => 
                                                                    setFormValues({
                                                                        ...formValues,
                                                                        [e.target.name]: sanitizeInput(e.target.value)
                                                                    })
                                                                }
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="contact-infolist-box">
                                                        <div className="contact-info-label">
                                                            <span>성별</span> <span className='essential'>*</span>
                                                        </div>
                                                        <div className="info-value-default">
                                                            <div className="radio-group">
                                                                <label className={`radio-box ${formValues.sexCd === 'M' ? 'active' : ''}`}>
                                                                    <input
                                                                        type="radio"
                                                                        name="sexCd"
                                                                        value="M"
                                                                        checked={formValues.sexCd === 'M'}
                                                                        onChange={(e) => 
                                                                            setFormValues({
                                                                                ...formValues,
                                                                                [e.target.name]: e.target.value
                                                                            })
                                                                        }
                                                                    />
                                                                    <span className="custom-radio" />
                                                                    <span className="label-text">남자</span>
                                                                </label>

                                                                <label className={`radio-box ${formValues.sexCd === 'F' ? 'active' : ''}`}>
                                                                    <input
                                                                        type="radio"
                                                                        name="sexCd"
                                                                        value="F"
                                                                        checked={formValues.sexCd === 'F'}
                                                                        onChange={(e) => 
                                                                            setFormValues({
                                                                                ...formValues,
                                                                                [e.target.name]: e.target.value
                                                                            })
                                                                        }
                                                                    />
                                                                    <span className="custom-radio" />
                                                                    <span className="label-text">여자</span>
                                                                </label>
                                                                </div>
                                                            </div>
                                                    </div>
                                                </div>

                                                <div className="flex-area half">
                                                    <div className="contact-infolist-box">
                                                        <div className="contact-info-label">
                                                            <span>생년월일</span><span className='essential'>*</span>
                                                        </div>

                                                        <div className="info-value-default">
                                                            <input 
                                                                type="text"
                                                                name="birthDay"
                                                                placeholder="생년월일을 입력해주세요."
                                                                value={formValues.birthDay}
                                                                onChange={(e) => 
                                                                    setFormValues({
                                                                        ...formValues,
                                                                        [e.target.name]: sanitizeInput(e.target.value)
                                                                    })
                                                                }
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="contact-infolist-box">
                                                        <div className="contact-info-label">
                                                            <span>연락처</span><span className='essential'>*</span>
                                                        </div>
                                                        <div className="info-value-default">
                                                            <input
                                                                type="text"
                                                                name="hpNo"
                                                                placeholder="-없이 입력해주세요."
                                                                value={formValues.hpNo}
                                                                onChange={(e) => 
                                                                    setFormValues({
                                                                        ...formValues,
                                                                        [e.target.name]: sanitizeInput(e.target.value)
                                                                    })
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="contact-infolist-box">
                                                    <div className="contact-info-label">
                                                        <span>회사명/단체명</span><span className='essential'>*</span>
                                                    </div>
                                                    <div className="info-value-default mb-8">
                                                        <input
                                                            type="text"
                                                            name="customerNm"
                                                            placeholder="회사명/단체명을 입력해주세요."
                                                            value={formValues.customerNm}
                                                            onChange={(e) => 
                                                                setFormValues({
                                                                    ...formValues,
                                                                    [e.target.name]: sanitizeInput(e.target.value)
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                <div className="contact-infolist-box">
                                                    <div className="contact-info-label">
                                                        <span>코드등록</span><span className='essential'>*</span>
                                                    </div>
                                                    <div className="info-value-default mb-8 add-code-wrapper">
                                                        <input
                                                            type="code"
                                                            name="voucherCode"
                                                            placeholder="코드번호를 입력해주세요."
                                                            value={formValues.voucherCode}
                                                            onChange={(e) => 
                                                                setFormValues({
                                                                    ...formValues,
                                                                    [e.target.name]: sanitizeInput(e.target.value)
                                                                })
                                                            }
                                                        />

                                                        <button type="button" className={`btn-gray ${formValues.voucherCode !== "" ? "active" : ""}`} onClick={() => validationCodeBtnClick()}>
                                                            <span>확인</span>
                                                        </button>
                                                    </div>

                                                    <div className={`info-value-msg ${codeResponseText !== '' ? 'show' : ''}`}>
                                                        <span className={`default ${isCodeValidateOk ? 'success' : 'error'}`}>* {codeResponseText}</span>
                                                    </div>
                                                </div>                                               
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <div className="btn-container">
                                <button
                                    type="button"
                                    className="btn-basic"
                                    onClick={() => submitBtnClick()}
                                >
                                     <span className="inquireMessage">
                                        신청하기
                                    </span>
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
            ) : (
                <></>
            )}

            <NotiPopup resetFormValues={resetFormValues}/>
        </>
    )
}

export default FreeVoucherPopup;
